import React from 'react';
import { FileWarning } from 'lucide-react';

/**
 * Factures page — provisoire banner shown when one or more drafts exist.
 * Renders nothing if `count === 0`. The "Filtrer" CTA jumps to the
 * Provisoire chip filter via the parent's setter.
 */
export default function FacturesProvisoireBanner({ count, onFilter }) {
  if (!count) return null;
  return (
    <div data-testid="provisoire-banner" className="soft-card p-3 flex items-center gap-3 bg-[#FEF2F2] border border-[#FECACA]">
      <FileWarning className="w-5 h-5 text-[#B91C1C] shrink-0" />
      <div className="flex-1 text-[13px] text-[#7F1D1D]">
        <strong>{count} facture{count > 1 ? 's' : ''} provisoire{count > 1 ? 's' : ''}</strong> — non comptabilisée{count > 1 ? 's' : ''} tant que non validée{count > 1 ? 's' : ''}. Le PDF porte le filigrane <em>PROVISOIRE</em>.
      </div>
      <button
        onClick={onFilter}
        className="h-8 px-3 rounded-lg bg-white border border-[#FECACA] text-[#B91C1C] text-[12px] font-semibold hover:bg-[#FEF2F2]"
      >
        Filtrer
      </button>
    </div>
  );
}
